import { Link, useNavigate } from "react-router-dom";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { useEffect, useState } from "react";
import { AddPet, EditPet, RemovePet } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../Common/Spinner";
import { GetAllPet, GetSinglePet } from "../../api/get";

import Loader from "../../loader";
import Header from "../../Common/Header";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import { Modal } from "react-responsive-modal";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";
const YourPet = () => {
  const [contentLoder, setContentLoader] = useState(true);
  const [pet, setPet] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoding] = useState(false);
  const [getPet, setGetPet] = useState([]);
  const [refresh, setRefresh] = useState(false); // Track changes
  const [petOpenSec, setPetOpensec] = useState();

  useEffect(() => {
    GetAllPet()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setGetPet(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refresh]);

  const validationSchema = Yup.object().shape({
    pet_name: Yup.string().required("Required field"),
    pet_type: Yup.string().required("Required field"),
  });
  const petFormik = useFormik({
    initialValues: {
      pet_name: "",
      pet_type: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      AddPet(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Pet added successfully");
            resetForm(); // This will clear the form fields
            setRefresh((prev) => !prev);
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  const EditPetFormik = useFormik({
    initialValues: {
      pet_name: "",
      pet_type: "",
      pet_id: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      EditPet(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Pet Updated Successfully");
            resetForm(); // This will clear the form fields
            setRefresh((prev) => !prev);
            setPetOpensec(null);
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  // Call GetSingleChild API when Edit button is clicked
  const fetchSinglePet = (id, index) => {
    // setPetOpensec(index);
    GetSinglePet(id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          console.log("ss", res);
          if (res && res.data.pet_name) {
            EditPetFormik.setValues({
              pet_name: res.data.pet_name,
              pet_type: res.data.pet_type,
              pet_id: id,
            });
            setPetOpensec(index); // Open the modal by setting the child index
          }
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((error) => {
        toast.error("Failed to fetch child details");
        console.error(error);
      });
  };

  const RemovePetFunction = (pet_id) => {
    RemovePet(pet_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setRefresh(!refresh); // Trigger refresh after deletion
          setPetOpensec(null);
          toast.success("Pet Removed Successfully");
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch(() => toast.error("Failed to remove child"));
  };
  return (
    <>
      {contentLoder ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1">
              <div>
                <div>
                  <h4 className="text-[36px] text-black font-bold mt-[36px]">
                    Add another pet
                  </h4>
                  <p className="text-slate-500 my-2">
                    If you add any pets we’ll ask you who you would like to look
                    after them later on. You can skip to the next page if you
                    don’t need to add any pets here.
                  </p>
                </div>
                <div>
                  <div className=" gap-5 mt-[30px]">
                    <form onSubmit={petFormik.handleSubmit} name="petForm">
                      <div className="mt-2 mb-4 ">
                        <FloatingLabelInput
                          label="Your pet's name"
                          type="text"
                          id="pet_name"
                          name="pet_name"
                          value={petFormik.values.pet_name}
                          onChange={petFormik.handleChange}
                          onBlur={petFormik.handleBlur}
                          error={
                            petFormik.touched.pet_name &&
                            petFormik.errors.pet_name
                          }
                        />
                      </div>
                      <div className="mt-2 mb-4 ">
                        <FloatingLabelInput
                          label="Type of pet"
                          type="text"
                          id="pet_type"
                          name="pet_type"
                          value={petFormik.values.pet_type}
                          onChange={petFormik.handleChange}
                          onBlur={petFormik.handleBlur}
                          error={
                            petFormik.touched.pet_type &&
                            petFormik.errors.pet_type
                          }
                        />
                      </div>
                      <div className="pb-5 border-b-2 border-dashed">
                        {loading === true ? (
                          <button className="border-2 w-full bg-primary flex justify-center rounded-[5px] border-[#240642] text-[#240642] px-4 py-2 hover:bg-primary hover:text-white transition-all ease-out font-bold">
                            <Spinner />
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="border-2 w-full rounded-[5px] border-[#240642] text-[#240642] px-4 py-2 hover:bg-primary hover:text-white transition-all ease-out font-bold"
                          >
                            Add a Pet
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                  {getPet && getPet.length > 0 ? (
                    getPet.map((pet, index) => (
                      <div
                        key={index}
                        className="border-2 rounded-lg p-3 w-full flex justify-between items-center mt-5"
                      >
                        <div className="flex">
                          <div>
                            <img
                              className=""
                              src={
                                pet.image ||
                                "/assets/images/document-header.png"
                              } // Use pet image if available
                              alt="pet"
                              style={{
                                height: "45px",
                                width: "45px",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                          <div className="mx-4">
                            <p className="text-[16px] font-bold">
                              {pet.pet_name} {"-"} {pet.pet_type}
                            </p>
                            <p className="text-[16px]">Your pets</p>
                          </div>
                        </div>
                        <button
                          onClick={() => fetchSinglePet(pet.id, index)}
                          className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                        >
                          Edit
                        </button>
                        <Modal
                          open={petOpenSec === index}
                          onClose={() => setPetOpensec(null)}
                          center
                          classNames={{
                            modal:
                              "rounded-[5px] p-5 w-[90%] sm:w-[75%] md:w-[60%] lg:w-[45%] xl:w-[35%] mx-auto", // Adjust modal width for different screen sizes
                          }}
                        >
                          <form
                            onSubmit={EditPetFormik.handleSubmit}
                            className="mx-5"
                          >
                            <div>
                              <h2 className="font-bold text-[20px] md:text-[24px]">
                                Edit Pet
                              </h2>
                              <input
                                type="hidden"
                                name="pet_id"
                                value={EditPetFormik.values.pet_id}
                              />
                              <div className="flex flex-col md:flex-row items-center gap-5 mt-[30px]">
                                <div className="w-full md:w-[50%]">
                                  <FloatingLabelInput
                                    label="Pet name"
                                    type="text"
                                    id={`pet_name`}
                                    name={"pet_name"}
                                    value={EditPetFormik.values.pet_name}
                                    onChange={EditPetFormik.handleChange}
                                    onBlur={EditPetFormik.handleBlur}
                                    error={
                                      EditPetFormik.touched.pet_name &&
                                      EditPetFormik.errors.pet_name
                                    }
                                  />
                                </div>
                                <div className="w-full md:w-[50%]">
                                  <FloatingLabelInput
                                    label="Pet Type"
                                    type="text"
                                    id={`pet_type`}
                                    name={"pet_type"}
                                    value={EditPetFormik.values.pet_type}
                                    onChange={EditPetFormik.handleChange}
                                    onBlur={EditPetFormik.handleBlur}
                                    error={
                                      EditPetFormik.touched.pet_type &&
                                      EditPetFormik.errors.pet_type
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col md:flex-row justify-between items-center gap-5 py-5">
                              <div className="w-full md:w-[50%]">
                                <button
                                  type="submit"
                                  className="w-full bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex justify-center items-center gap-2"
                                >
                                  Update Pet
                                </button>
                              </div>
                              <div className="w-full md:w-[50%]">
                                <button
                                  type="button"
                                  onClick={() =>
                                    RemovePetFunction(
                                      EditPetFormik.values.pet_id
                                    )
                                  }
                                  className="w-full border-[1px] border-[#240642] hover:bg-primary hover:text-white border-solid text-black px-5 py-3 font-muli font-semibold rounded-[5px] flex justify-center items-center gap-2"
                                >
                                  Remove Pet
                                </button>
                              </div>
                            </div>
                          </form>
                        </Modal>
                      </div>
                    ))
                  ) : (
                    <div className="py-5 w-[100%] ">
                      <p className="text-black font-bold">No pets available.</p>
                    </div>
                  )}
                  <div className="border-b-2 my-5"></div>
                  <div className="flex justify-between my-3">
                    <Link to={"/make-will-online/about-yourself/children"}>
                      <button className="flex items-center justify-center gap-1 font-semiold text-[20px] rounded-[10px] mt-5 text-slate-500">
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                    {saveLoading ? (
                      <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded">
                        <Spinner />
                      </button>
                    ) : (
                      <Link to={"/make-will-online/about-yourself/review"}>
                        <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1">
                          Next <FaChevronRight />
                        </button>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className="max-lg:hidden bg-no-repeat">
                <div className="fixed top-0 w-[600px] right-[6%] bg-cloud">
                  <img src="/assets/images/4.png" alt="mascot" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default YourPet;
